"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../../factory");
var hash_1 = require("../../utils/hash");
function createWebGLFingerprint() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    try {
                        var canvas = document.createElement('canvas');
                        canvas.width = 200;
                        canvas.height = 100;
                        var gl = canvas.getContext('webgl');
                        if (!gl) {
                            throw new Error('WebGL not supported');
                        }
                        var vertexShaderSource = "\n          attribute vec2 position;\n          void main() {\n              gl_Position = vec4(position, 0.0, 1.0);\n          }\n      ";
                        var fragmentShaderSource = "\n          precision mediump float;\n          void main() {\n              gl_FragColor = vec4(0.812, 0.195, 0.553, 0.921); // Set line color to white\n          }\n      ";
                        var vertexShader = gl.createShader(gl.VERTEX_SHADER);
                        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
                        if (!vertexShader || !fragmentShader) {
                            throw new Error('Failed to create shaders');
                        }
                        gl.shaderSource(vertexShader, vertexShaderSource);
                        gl.shaderSource(fragmentShader, fragmentShaderSource);
                        gl.compileShader(vertexShader);
                        gl.compileShader(fragmentShader);
                        var shaderProgram = gl.createProgram();
                        if (!shaderProgram) {
                            throw new Error('Failed to create shader program');
                        }
                        gl.attachShader(shaderProgram, vertexShader);
                        gl.attachShader(shaderProgram, fragmentShader);
                        gl.linkProgram(shaderProgram);
                        gl.useProgram(shaderProgram);
                        // Set up vertices to form lines
                        var numSpokes = 137;
                        var vertices = new Float32Array(numSpokes * 4);
                        var angleIncrement = (2 * Math.PI) / numSpokes;
                        for (var i = 0; i < numSpokes; i++) {
                            var angle = i * angleIncrement;
                            // Define two points for each line (spoke)
                            vertices[i * 4] = 0; // Center X
                            vertices[i * 4 + 1] = 0; // Center Y
                            vertices[i * 4 + 2] = Math.cos(angle) * (canvas.width / 2); // Endpoint X
                            vertices[i * 4 + 3] = Math.sin(angle) * (canvas.height / 2); // Endpoint Y
                        }
                        var vertexBuffer = gl.createBuffer();
                        gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
                        gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
                        var positionAttribute = gl.getAttribLocation(shaderProgram, 'position');
                        gl.enableVertexAttribArray(positionAttribute);
                        gl.vertexAttribPointer(positionAttribute, 2, gl.FLOAT, false, 0, 0);
                        // Render
                        gl.viewport(0, 0, canvas.width, canvas.height);
                        gl.clearColor(0.0, 0.0, 0.0, 1.0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        gl.drawArrays(gl.LINES, 0, numSpokes * 2);
                        var dataURL = canvas.toDataURL();
                        // Close WebGL context
                        gl.deleteProgram(shaderProgram);
                        gl.deleteShader(vertexShader);
                        gl.deleteShader(fragmentShader);
                        canvas.remove();
                        resolve({
                            'imageHash': (0, hash_1.hash)(JSON.stringify(dataURL)).toString(),
                            //'dataUrl': dataURL, // a hash is smaller
                            'renderer': gl.getParameter(gl.RENDERER),
                            'vendor': gl.getParameter(gl.VENDOR),
                            'version': gl.getParameter(gl.VERSION),
                            'shadingLanguageVersion': gl.getParameter(gl.SHADING_LANGUAGE_VERSION)
                        });
                    }
                    catch (error) {
                        resolve({
                            'webgl': 'unsupported'
                        });
                    }
                })];
        });
    });
}
(0, factory_1.includeComponent)('webgl', createWebGLFingerprint);
//# sourceMappingURL=webgl.js.map